import React from 'react';
import { Box, Typography } from '@mui/material';
// import data from './data.json';

const AboutUs = () => {
  return (
    <Box sx={{my: 2, mb: '51px'}}>
      <Typography variant="h4" component="h1" color="secondary" align="center">
        About Us
      </Typography>
      <Box sx={{mt: 2}}>
        <Typography variant="body2" sx={{mb: 2}}>
          We book is a platform to empower entrepreneurs and businesses with coaching centres and reading rooms by providing technological expertise to maximise demand and revenue through utilisation of existing resources more efficiently.
        </Typography>
        <Typography variant="body2" sx={{mb: 2}}>
          We strive to make life of a student hassle-free by providing affordable access to reading rooms and coaching centres through instant booking.
        </Typography>
        <Typography variant="body2" sx={{mb: 2}}>
          We help students make informed choice by comparing features of different institutes.
        </Typography>
        <Typography variant="body2" sx={{mb: 2}}>
          we book provides real-time availability of seats in reading rooms and coaching centres.
        </Typography>
        <Typography variant="body2" sx={{mb: 2}}>
          we book helps institutes in multiplying revenue channels and to reach more students by optimising experience.
        </Typography>
        <Typography variant="body2" sx={{mb: 2}}>
          We help institutes save marketing costs by providing proper visibility to target audience.
        </Typography>
      </Box>
      {/* <Copyright /> */}
    </Box>
  );
}
 
export default AboutUs;
